import { ROUTE_NAMES } from '#/router/routes';
import React, { ImgHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

interface IProperties {
  id: string;
  image: ImgHTMLAttributes<HTMLImageElement>['src'];
  name: string;
}

const AlbumBanner = (properties: IProperties) => {
  const { id, image, name } = properties;
  return (
    <Link to={`${ROUTE_NAMES.ALBUM}/${id}`}>
      <div className="flex gap-4 w-full hover:bg-theme-light-gray/10 rounded-t-md overflow-hidden">
        <div className=" h-20 aspect-square">
          <img className="w-full h-full object-cover" src={image} alt="" />
        </div>
        <div className="flex flex-col gap-2 justify-center">
          <span className="text-xs leading-none">From the album</span>
          <span className="text-base font-bold leading-none hover:underline">
            {name}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default AlbumBanner;
